import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App.tsx'
import './index.css'
import { installGlobalErrorHandlers } from './stdlib/stdlib-globalerrorhandler.ts';
import { StdlibErrorBoundary } from './stdlib/stdlib-errorboundry.tsx';

installGlobalErrorHandlers();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <StdlibErrorBoundary>
      <App />
    </StdlibErrorBoundary>
  </React.StrictMode>,
)
